/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 * hours is a dict with each day of the week being key, and a list of string tuples in format(hh:mm) as values
 * Example:
 *   If user sets business hours for monday as two intervals: 8AM to 5 PM and 9 PM to midnight.
 *   'monday': [("08:00", "17:00"), ("21:00", "24:00")]
 * if start time is 12AM, it is received as "00:00"
 * if end time is 12 AM, it is received as "24:00"
 * if business hours are closed for the day, that day can be omitted or with value []
 * @export
 * @interface TimegateSettings
 */
export interface TimegateSettings {
  /**
   * check interval in minutes
   * @type {number}
   * @memberof TimegateSettings
   */
  checkIntervalInMinutes?: number;
  /**
   * Business hours specification
   * @type {{ [key: string]: Array<Array<any>>; }}
   * @memberof TimegateSettings
   */
  hours?: { [key: string]: Array<Array<any>> };
  /**
   * Max number of times the timegate can be retried
   * @type {number}
   * @memberof TimegateSettings
   */
  maxRetries?: number;
  /**
   * Timezone name. For example, "US/Pacific"
   * @type {string}
   * @memberof TimegateSettings
   */
  timezone?: string;
  /**
   * Modes to determine timezone for the timegate.
   * @type {string}
   * @memberof TimegateSettings
   */
  timezoneMode?: TimegateSettingsTimezoneModeEnum;
}

/**
 * @export
 */
export const TimegateSettingsTimezoneModeEnum = {
  Phone: 'phone',
  Lead: 'lead',
  Address: 'address',
  AddressAndPhone: 'address_and_phone',
} as const;
export type TimegateSettingsTimezoneModeEnum =
  (typeof TimegateSettingsTimezoneModeEnum)[keyof typeof TimegateSettingsTimezoneModeEnum];

/**
 * Check if a given object implements the TimegateSettings interface.
 */
export function instanceOfTimegateSettings(
  value: object,
): value is TimegateSettings {
  return true;
}

export function TimegateSettingsFromJSON(json: any): TimegateSettings {
  return TimegateSettingsFromJSONTyped(json, false);
}

export function TimegateSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TimegateSettings {
  if (json == null) {
    return json;
  }
  return {
    checkIntervalInMinutes:
      json['check_interval_in_minutes'] == null
        ? undefined
        : json['check_interval_in_minutes'],
    hours: json['hours'] == null ? undefined : json['hours'],
    maxRetries: json['max_retries'] == null ? undefined : json['max_retries'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
    timezoneMode:
      json['timezone_mode'] == null ? undefined : json['timezone_mode'],
  };
}

export function TimegateSettingsToJSON(value?: TimegateSettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    check_interval_in_minutes: value['checkIntervalInMinutes'],
    hours: value['hours'],
    max_retries: value['maxRetries'],
    timezone: value['timezone'],
    timezone_mode: value['timezoneMode'],
  };
}
